'use client';

import type { HTMLChakraProps, RecipeProps } from '@chakra-ui/react';
import { createRecipeContext } from '@chakra-ui/react';
import { Link, LinkProps } from 'react-router-dom';

export interface LinkButtonProps extends HTMLChakraProps<'a', RecipeProps<'button'> & LinkProps> {}

const { withContext } = createRecipeContext({ key: 'button' });

export const LinkButton = withContext<HTMLAnchorElement, LinkButtonProps>(Link);
